import { attributeChangesRegister } from '@/core/item_assistance/unsavedDataManager'
import { getAttributeNameWithoutPostfix } from '@/core/shared'

export function bindResetButton () {
	$('div.page').on('click', '.button_reset', function (e) {
		let input = $(this).prev()
		if (input.is('input') || input.is('textarea')) {
			input.val('').trigger('input')
		}
		attributeChangesRegister(getAttributeNameWithoutPostfix(input.attr('id')))
		e.stopPropagation()
	})
}

export function bindResetButtonModal () {
	$('.button_reset').unbind('click')
	$('.button_reset').on('click', function () {
		$(this).parent().find('input, textarea').val('')
	})
}
